export default __webpack_public_path__ + "static/media/proposal_dropdown.21373d0e.svg";